import React, { memo } from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
import EditableField from './EditableField.jsx';

const ComparisonRow = memo(({ section, fieldPrefix, criteria, hiperpan, isHighlight = false, delay = 0 }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, x: -10 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3, delay }}
      className={`grid grid-cols-3 md:grid-cols-4 items-center gap-1 sm:gap-2 md:gap-4 p-3 sm:p-4 md:p-5 border-b border-border transition-colors hover:bg-muted/30 ${isHighlight ? 'bg-primary/5 border-l-4 border-l-primary rounded-r-lg' : ''}`}
    >
      <div className="col-span-1">
        <EditableField section={section} field={`${fieldPrefix}.criteria`} value={criteria} className="font-body font-bold text-[10px] sm:text-xs md:text-sm text-foreground/90 w-full block text-balance" />
      </div>
      
      <div className="col-span-1 md:col-span-1 flex flex-col items-center justify-center text-center">
        <div className="bg-emerald-100 text-emerald-700 font-bold px-1.5 py-1 sm:px-3 sm:py-1.5 rounded-lg flex items-center justify-center gap-1 sm:gap-1.5 w-full shadow-sm text-[10px] sm:text-xs md:text-sm">
          <Check className="w-3 h-3 sm:w-3.5 sm:h-3.5 hidden sm:block shrink-0" aria-hidden="true" />
          <EditableField section={section} field={`${fieldPrefix}.hiperpan`} value={hiperpan} className="w-full block leading-snug break-words whitespace-normal" />
        </div>
      </div>
      
      <div className="col-span-1 flex items-center justify-center text-center opacity-60">
        <X className="w-4 h-4 sm:w-5 sm:h-5 text-destructive shrink-0" aria-hidden="true" />
      </div>

      <div className="hidden md:flex col-span-1 items-center justify-center text-center opacity-60">
        <X className="w-5 h-5 text-destructive shrink-0" aria-hidden="true" />
      </div>
    </motion.div>
  );
});

ComparisonRow.displayName = 'ComparisonRow';
export default ComparisonRow;